import { http } from '../http'
import { FilterOptions, IFilter, IFilters, INewFilter } from './filters.types'

export const ApiPathsFilters = {
  filters: (filter?: FilterOptions[]) => `/filters${filter ? `?filters=${filter.join(',')}` : ''}`,
}

export const getFilters = async (url: string): Promise<IFilters> => {
  const { data } = await http.get(url)
  return data
}

export const addFilter = async (url: string, { arg }: { arg: INewFilter }): Promise<IFilter> => {
  const { data } = await http.post(url, arg)
  return data
}
